import List from '../components/list.js';
import { useState, useContext, useEffect, useRef } from 'react';
import Context, { AccessContext } from '../components/context.js';
import { Link, useNavigate } from 'react-router-dom';
import Dialog from '../components/dialog.jsx';
import axios from 'axios';

const SpeakerName = ({imageUrl, name}) => {
    return (
        <div className="speaker-list-title-container">
            <img src={imageUrl.startsWith('http') ? imageUrl : process.env.REACT_APP_MEDIA_URL + imageUrl} alt={name} />
            <div style={{maxWidth: 250}}>{name}</div>
        </div>
    );
}
const HostList = ({IsGuest = 0}) => {
    const navigate = useNavigate();
    const addSpeakerRef = useRef(null);
    const speakerListRef = useRef(null);
    const access = useContext(AccessContext);
    const [hosts, setHosts] = useState([]);
    const [search, setSearch] = useState('');
    const [speakerSearch, setSpeakerSearch] = useState('');
    const [loading, setLoading] = useState(true);
    const setContext = useContext(Context)[1];
    const [checks, setChecks] = useState([]);
    const [currentPage, setCurrentPage] = useState(0);
    const [totalRecords, setTotalRecords] = useState(0);
    setContext('Hosts');
    const headings = [
        { key: 'id', name: 'ID', hide: true },
        { key: ['imageUrl', 'name'], name: IsGuest ? 'Guest Name' : 'Host Name', link: false, linkKey: 'id', Component: SpeakerName },
        { key: 'profession', name: 'Profession', center: true },
        { key: 'episodes', name: 'Episodes', center: true },
        { key: 'primary', name: 'Primary Host', center: true, hide: IsGuest == 1 },
    ]
    const loadHosts = (page, primarySearch) => {
        setLoading(true);
        axios.post(process.env.REACT_APP_API_URL + 'podcast/speakers',{
            page: page,
            isGuest: IsGuest,
            search: primarySearch ?? speakerSearch
        }).then(r => {
            setLoading(false);
            if (r?.data?.status === 'Success') {
                let now = new Date();
                setTotalRecords(r.data.total);
                setHosts(r.data.results.map(res => {
                    let nextEvent = 'No Events';
                    if (res.events?.length > 0) {
                        let eventDates = res.events.map(e => new Date(e.datetime));
                        let ned = eventDates.sort((a, b) => new Date(a) - new Date(b)).find(d => new Date(d) > now);
                        if (ned) {
                            nextEvent = ned.toLocaleDateString();
                        }
                    }
                    res.primary = res.isPrimary ? 'Yes' : 'No'
                    let name = res.lastName ? res.firstName + ' ' + res.lastName : res.firstName;
                    res.name = name;
                    res.nextEvent = nextEvent;
                    res.episodes = res.episodesCount || res.episodes?.length || 0;
                    res.profession = res.metaData?.professions ? res.metaData.professions.join('/') : 'None';
                    return res
                }));
            }
        });
    }
    const [searchedHosts, setSearchedHosts] = useState([]);
    const [isSearching, setIsSearching] = useState(false);
    const [isAdding, setIsAdding] = useState(false);
    const searchHost = () =>
    {
        setSearchedHosts([]);
        if (search == '')
            return;
        if (isSearching)
            return;
        setIsSearching(true);
        axios.post(process.env.REACT_APP_API_URL + (IsGuest ? 'guest' : 'host'), {
            search: search,
            page: 0
        }).then(r => {
            setIsSearching(false);
            if (r?.data?.status === 'Success') {
                let now = new Date();
                setSearchedHosts(r.data.results.filter(x => !hosts.some(y => x.id === y.id)).map(res => {
                    let name = res.lastName ? res.firstName + ' ' + res.lastName : res.firstName;
                    res.name = name;
                    res.episodes = res.episodes?.length || 0;
                    return res
                }));
                setSearch('');
            }
        });
    }
    const addHost = (id) => {
        if (isAdding)
            return;
        setIsAdding(true);
        axios.post(process.env.REACT_APP_API_URL + 'podcast/speakers/add', {
            speakerId: id,
            isPrimary: 0,
            isGuest: IsGuest
        }).then(r => {
            loadHosts(0);
            setSearchedHosts([]);
            setSearch('');
            setIsAdding(false);
        });
    }
    const updateHost = (id, primary) => {
        if (isAdding)
            return;
        setIsAdding(true);
        axios.post(process.env.REACT_APP_API_URL + 'podcast/speakers/update', {
            speakerId: id,
            isPrimary: primary
        }).then(r => {
            loadHosts(0);
            setIsAdding(false);
        });
    }
    useEffect(() => {
        setCurrentPage(0);
        setSpeakerSearch('');
        setSearchedHosts([]);
        setSearch('');
        setHosts([]);
        loadHosts(0, '');
    }, [IsGuest]);
    useEffect(() => {
        setChecks(Array.apply(null, Array(hosts?.length)).map(() => false));
    }, [hosts]);
    const pageSize = 20;
    var pages = [];
    for (var i = Math.max(0, currentPage - 3); i < Math.min(currentPage + 4, Math.ceil(totalRecords / pageSize)); i++) {
        pages.push(i);
    }
    const speakerDialogClose = () => {
        setSearchedHosts([]);
        setSearch('');
    }
    return (
        <main>
            <Dialog ref={addSpeakerRef} onClose={speakerDialogClose} outsideButtons={(
                <div className="flex gap-5 f-end p-abs" style={{bottom: -38, right: 0, background: 'transparent', padding: 0}}>
                    <button className="btn btn-white" onClick={() => {
                        speakerListRef.current.show();
                        addSpeakerRef.current.hide();
                        searchHost();
                    }}>Search</button>
                    <button className="btn btn-white" onClick={() => {
                        addSpeakerRef.current.hide();
                        speakerDialogClose();
                    }}>Cancel</button>
                </div>
            )}>
                <div style={{ flexGrow: 0, maxWidth: '100%', width: 500 }} className="w-100 p-rel">
                    <div className="input-with-icon">
                        <svg role="button" style={{cursor: 'pointer', pointerEvents: 'all'}} onClick={() => { 
                            speakerListRef.current.show();
                            addSpeakerRef.current.hide();
                            searchHost();
                        }} width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M7.33333 12.6667C10.2789 12.6667 12.6667 10.2789 12.6667 7.33333C12.6667 4.38781 10.2789 2 7.33333 2C4.38781 2 2 4.38781 2 7.33333C2 10.2789 4.38781 12.6667 7.33333 12.6667Z" stroke="#99A1AF" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M14.0005 13.9995L11.1338 11.1328" stroke="#99A1AF" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                        <input type="search" aria-label="Search Episodes" placeholder={IsGuest ? "Search Guests" : "Search Hosts"} value={search} onChange={(e) => setSearch(e.target.value)} onKeyDown={(e) => {
                            if (e.code.toLowerCase() == 'enter') {
                                speakerListRef.current.show();
                                addSpeakerRef.current.hide();
                                searchHost();
                            }
                        }} className="w-100" />
                    </div>
                </div>
            </Dialog>
            <Dialog ref={speakerListRef} onClose={speakerDialogClose} outsideButtons={(
                <div className="flex gap-5 f-end p-abs" style={{bottom: -38, right: 0, background: 'transparent', padding: 0}}>
                    <button className="btn btn-white" onClick={() => {
                        speakerListRef.current.hide();
                        speakerDialogClose();
                    }}>Close</button>
                </div>
            )}>
                <div style={{ flexGrow: 0, maxWidth: '100%', width: 500 }} className="w-100 p-rel host-search-results">
                    {isSearching ? (
                        <div style={{padding: 3, textAlign: 'center', display: 'flex', justifyContent: 'center'}}>
                            <div className="spinner blue" style={{borderWidth: 4, width: 32}}></div>
                        </div>
                    ) : (searchedHosts.length > 0 ?
                        searchedHosts.map((h, i) => (
                            <div key={i} className="flex f-row f-between gap-10">
                                {!!h.imageUrl && (
                                    <img className="item-image" src={process.env.REACT_APP_MEDIA_URL + h.imageUrl} alt={h.name} />
                                )}
                                <div className="mr-auto">{h.name}</div>
                                <a role="button" onClick={() => addHost(h.id)} className="btn">Add</a>
                            </div>
                        )) : (
                            <div style={{padding: 20, textAlign: 'center'}}>
                                No {IsGuest ? 'Guests' : 'Hosts'} Found
                            </div>
                        )
                    )}
                </div>
            </Dialog>
            <div className="container mw-750 w-100">
                <div className="form mb-15">
                    <div className="flex f-row f-between a-center f-wrap">
                        <div style={{display: 'block', flexGrow: 0}}>
                            <h1 className="page-title">Podcast {IsGuest ? 'Guests' : 'Hosts'}</h1>
                            <h2 className="page-subtitle">Add and manage your podcast's {IsGuest ? 'guests' : 'hosts'}.</h2>
                        </div>
                        <div className="flex f-end f-row a-center list-top-buttons" style={{gap: 8, flexGrow: 0}}>
                            <a role="button" className="btn flex a-center f-row xs-w-100 add-button" style={{gap: 8}} onClick={() => addSpeakerRef.current.show()}>
                                <svg width="16" height="16" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M2.5 6H9.5" stroke="#FFF" stroke-linecap="round" stroke-linejoin="round"></path>
                                    <path d="M6 2.5V9.5" stroke="#FFF" stroke-linecap="round" stroke-linejoin="round"></path>
                                </svg>
                                <span>Add {IsGuest ? 'Guest' : 'Host'}</span>
                            </a>
                        </div>
                    </div>
                    {IsGuest == 1 && (
                        <div className="w-100 ml-auto gap-10 f-row f-end p-rel">
                            <div className="content-box w-100">
                                <div className="content-body" style={{padding: 17}}>
                                    <div className="input-with-icon">
                                        <svg role="button" style={{cursor: 'pointer', pointerEvents: 'all'}} onClick={() => { 
                                            loadHosts(0);
                                            setCurrentPage(0);
                                         }} width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M7.33333 12.6667C10.2789 12.6667 12.6667 10.2789 12.6667 7.33333C12.6667 4.38781 10.2789 2 7.33333 2C4.38781 2 2 4.38781 2 7.33333C2 10.2789 4.38781 12.6667 7.33333 12.6667Z" stroke="#99A1AF" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
                                            <path d="M14.0005 13.9995L11.1338 11.1328" stroke="#99A1AF" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
                                        </svg>
                                        <input type="search" aria-label="Search Episodes" placeholder={IsGuest ? "Search Added Guests" : "Search Added Hosts"} value={speakerSearch} onChange={(e) => setSpeakerSearch(e.target.value)} onKeyDown={(e) => {
                                            if (e.code.toLowerCase() == 'enter') {
                                                loadHosts(0);
                                                setCurrentPage(0);
                                            }
                                        }} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
                <List list={hosts} href="host" checkBoxes={false} headings={headings} loading={loading} onCheck={setChecks} actions={[{
                    text: (e) => {
                        return !e.isPrimary ? 'Make Primary' : 'Remove Primary'
                    },
                    action: (e) => {
                        setLoading(true);
                        updateHost(e.id, !e.isPrimary);
                    },
                    hide: (e) => IsGuest == 1
                }, {
                    text: (e) => {
                        return 'Remove'
                    },
                    action: (e) => {
                        console.log(e);
                        setLoading(true);
                        axios.post(process.env.REACT_APP_API_URL + 'podcast/speakers/delete', {
                            speakerId: e.id,
                            isGuest: IsGuest
                        }).then(r => {
                            loadHosts(0);
                        });
                    },
                    hide: (e) => {
                        return e.episodes > 0
                    }
                }, {
                    text: (e) => {
                        return 'Edit'
                    },
                    action: (e) => {
                        navigate('/host', { state: { id: e.id } });
                    },
                    hide: (e) => {
                        return !access?.podcastMetaData?.speakerId?.includes(e.id) && (access.role == 'Podcast' || access.role == 'Producer');
                    }
                }]} footerContent={
                    <div className="flex f-row w-100 a-center f-between">
                        <div className="showing-pages">
                            Showing <b>{hosts.length}</b> of <b>{totalRecords}</b>
                        </div>
                        <div className="list-arrows mt-0">
                            <button className="btn-arrow" disabled={currentPage <= 0} onClick={() => {
                                if (currentPage <= 0)
                                    return;
                                loadHosts(currentPage - 1);
                                setCurrentPage(c => c - 1);
                            }}>Prev</button>
                            {pages.map(p => (
                                <button key={p} className={(p == currentPage ? 'btn current-page' : '')} onClick={() => {
                                    loadHosts(p);
                                    setCurrentPage(p);
                                }}>{p + 1}</button>
                            ))}
                            <button className="btn-arrow" disabled={(currentPage + 1) * pageSize >= totalRecords - 1} onClick={() => {
                                if ((currentPage + 1) * pageSize >= totalRecords - 1)
                                    return;
                                loadHosts(currentPage + 1);
                                setCurrentPage(c => c + 1);
                            }}>Next</button>
                        </div>
                    </div>
                } />
                {access.role == 'Super' && (
                    <div class="mt-10 flex f-end f-col">
                        <Link to="/manage-profiles" class="btn">Manage Profiles</Link>
                    </div>
                )}
            </div>
        </main>
    )
}

export default HostList;